document.addEventListener("DOMContentLoaded", function() {
  // Toggle Visibility
  $(document).on('click', '.toggle-paragraph-visibility-button', function(clickEvent) {
    const $paragraphButton = $(clickEvent.currentTarget);
    const paragraphPosition = $paragraphButton.data("paragraph-position");
    const paragraphId = $paragraphButton.data("paragraph-id")
    $("#toggle-visibility-source-paragraph-position").html(paragraphPosition);
    $("#toggle_visibility_source_paragraph_id").val(paragraphId);
  });

  // Toggle Interaction
  $(document).on('click', '.toggle-paragraph-interaction-button', function(clickEvent) {
    const $paragraphButton = $(clickEvent.currentTarget);
    const paragraphPosition = $paragraphButton.data("paragraph-position");
    const paragraphId = $paragraphButton.data("paragraph-id")
    $("#toggle-interaction-source-paragraph-position").html(paragraphPosition);
    $("#toggle_interaction_source_paragraph_id").val(paragraphId);
    $("#toggle-paragraph-interaction-submit").trigger("click");
  });

  // Move
  $(document).on("click", ".move-paragraph-button", function(clickEvent) {
    const $paragraphButton = $(clickEvent.currentTarget);
    const paragraphPosition = $paragraphButton.data("paragraph-position");
    const paragraphId = $paragraphButton.data("paragraph-id")
    $("#move-source-paragraph-position").html(paragraphPosition);
    $("#move_source_paragraph_id").val(paragraphId);
  });

  $('#position_to_move_to').on('keyup', function() {
    const $positionToMoveTo = $("#position_to_move_to");
    const maxPosition = parseInt($positionToMoveTo.attr("max")) || 1;
    const inputValue = parseInt($positionToMoveTo.val());
    const sourcePosition = parseInt($("#move-source-paragraph-position").html());

    if (inputValue != NaN && inputValue > 0 && inputValue <= maxPosition && inputValue != sourcePosition) {
      $("#move-paragraph-submit").prop("disabled", false);
    }
    else {
      $("#move-paragraph-submit").prop("disabled", true);
    }
  });

  // Destroy
  $(document).on('click', '.destroy-paragraph-button', function(clickEvent) {
    const $paragraphButton = $(clickEvent.currentTarget);
    const paragraphPosition = $paragraphButton.data("paragraph-position");
    const paragraphId = $paragraphButton.data("paragraph-id")
    $("#destroy-source-paragraph-position").html(paragraphPosition);
    $("#destroy_source_paragraph_id").val(paragraphId);
  });

  // Merge
  $(document).on('click', '.merge-paragraph-button', function(clickEvent) {
    const $paragraphButton = $(clickEvent.currentTarget);
    const paragraphPosition = $paragraphButton.data("paragraph-position");
    const paragraphId = $paragraphButton.data("paragraph-id")
    $("#merge-source-paragraph-position").html(paragraphPosition);
    $("#merge_source_paragraph_id").val(paragraphId);

    $("#merge_target_paragraph_id").val(null);
    $("#merge_target_paragraph_position").val(null);
    $("#merge-preview-container").html("");
    $("#merge-preview").hide();
    $("#merge-paragraphs-submit").prop("disabled", true);
  });

  $('#merge_target_paragraph_position').on('keyup', function() {
    const target = document.querySelector(`[data-paragraph-body-position="${$('#merge_target_paragraph_position').val()}"]`);
    const source = document.querySelector(`#paragraph-body-${$('#merge_source_paragraph_id').val()}`);
    const $previewContainer = $("#merge-preview-container");

    if (target && source && target != source && target.dataset.mergeable && source.dataset.mergeable) {
      $previewContainer.html(
      `
        <ul class="participatory-text-list">
          <li class="participatory-text-item">
            <h5>${Math.min(source.dataset.paragraphBodyPosition, target.dataset.paragraphBodyPosition)}</h5>
            ${source.innerHTML}
            ${target.innerHTML}
          </li>
        </ul>
      `
      );
      $("#merge_target_paragraph_id").val(target.dataset.paragraphBodyId);
      $("#merge-preview").show();
      $("#merge-paragraphs-submit").prop("disabled", false);
    }
    else {
      $previewContainer.html("");
      $("#merge-preview").hide();
      $("#merge-paragraphs-submit").prop("disabled", true);
    }
  });

  $('.manipulate-paragraph').on('ajax:complete', function(event) {
    xhr = event.detail[0]

    if (xhr.status >= 200 && xhr.status < 300) {
      const response = JSON.parse(xhr.responseText);

      if (response && response.redirectTo) {
        const redirectUrl = new URL(response.redirectTo, window.location.origin);
        window.location.href = redirectUrl.toString();
        return;
      }
    }
    location.reload();
  });
});
